import React from 'react';
import { whyChooseUs } from '../data/mock';
import { CheckCircle } from 'lucide-react';

const WhyChooseUs = () => {
  return (
    <section id="why-choose" style={{ background: 'var(--bg-primary)', padding: '100px 7.6923%', borderTop: '1px solid var(--border-subtle)' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        
        {/* SEO Optimized Headers */}
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <h2 className="display-large" style={{ marginBottom: '20px' }}>
            Why Choose Ciqura Labs Indore
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '800px', margin: '0 auto' }}>
            What makes our practical hacker labs and production-grade Python engineering tracks completely stand out from other standard training institutes in Vijay Nagar.
          </p>
        </div>

        {/* Dynamic Card Layout Grid */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' }}>
          {whyChooseUs.map((item) => (
            <div key={item.id} style={{ background: 'var(--bg-secondary)', padding: '30px', border: '1px solid var(--border-subtle)', display: 'flex', gap: '20px', transition: 'all 0.4s ease-in-out' }} className="dark-hover">
              <CheckCircle size={24} style={{ color: 'var(--brand-primary)', flexShrink: 0 }} />
              <div>
                <h3 className="heading-3" style={{ marginBottom: '8px' }}>{item.title}</h3>
                <p className="body-medium" style={{ color: 'var(--text-secondary)', lineHeight: '1.6' }}>{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Visible Content Block to maximize keyword depth */}
        <article style={{ marginTop: '60px', background: 'rgba(0, 255, 209, 0.02)', border: '1px dashed var(--border-subtle)', padding: '30px', borderRadius: '8px', textAlign: 'center', color: 'var(--text-secondary)' }}>
          <p className="body-medium" style={{ margin: 0, lineHeight: '1.7' }}>
            As the corporate training arm of <strong>Ciqur24 LLP</strong>, we don't follow generic blueprints. Every program module is constantly refined against the latest active vulnerability reports, cloud changes, and software deployment pipelines—ensuring our students emerge with functional technical dominance.
          </p>
        </article>

      </div>
    </section>
  );
};

export default WhyChooseUs;